'use client';
import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslation';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div style={{minHeight:'72vh',display:'flex',alignItems:'center',justifyContent:'center',textAlign:'center',padding:'80px 24px',background:'#fff'}}>
      <div>
        <div style={{fontFamily:"'DM Serif Display',serif",fontSize:100,background:'linear-gradient(135deg,#0077FF,#7C3AED)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',backgroundClip:'text',lineHeight:1,marginBottom:20}}>404</div>
        <h1 style={{fontFamily:"'DM Serif Display',serif",fontSize:32,color:'#1A202C',marginBottom:12}}>{t('notfound.heading')}</h1>
        <p style={{fontSize:16,color:'#6B7280',maxWidth:380,margin:'0 auto 28px',lineHeight:1.7}}>{t('notfound.sub')}</p>
        <div style={{display:'flex',gap:14,justifyContent:'center'}}>
          <Link href="/" style={{background:'linear-gradient(135deg,#3B82F6,#5232FF)',color:'#fff',padding:'13px 28px',borderRadius:8,fontSize:15,fontWeight:600,textDecoration:'none',boxShadow:'0 4px 14px rgba(82,50,255,0.25)'}}>{t('btn.go_home')}</Link>
          <Link href="/resources/" style={{background:'#fff',color:'#0077FF',padding:'12px 28px',borderRadius:8,fontSize:15,fontWeight:600,border:'1.5px solid #E8EDF5',textDecoration:'none'}}>{t('btn.browse_resources')}</Link>
        </div>
      </div>
    </div>
  );
}
